<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="广告主题:" prop="title">
          <Input v-model="formFields.label" placeholder="请输入广告主题..." size="small" />
        </FormItem>
        <FormItem label="播放时长(s):" prop="duration">
          <Input v-model="formFields.duration" placeholder="请输入播放时长..." size="small" />
        </FormItem>
        <FormItem label="显示策略:" prop="showPolicy">
          <Select
            v-model="formFields.showPolicy"
            placeholder="请选择显示策略..."
            filterable
            size="small"
          >
            <Option v-for="(option, index) in showPolicyList" :key="index" :value="option.value" :label="option.label" />
          </Select>
        </FormItem>
        <FormItem label="广告标签:" prop="tag">
          <Input v-model="formFields.serialNumber" placeholder="请输入广告标签..." size="small" />
        </FormItem>
        <FormItem label="是否启用:" prop="enabled">
          <RadioGroup v-model="formFields.enabled">
            <Radio :label="1" :true-value="1">
              启用
            </Radio>
            <Radio :label="0" :true-value="0">
              禁用
            </Radio>
          </RadioGroup>
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" :disabled="loadingStatus" size="small" icon="ios-checkmark-circle-outline" :loading="submit" @click="saveOrUpdate">
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { applyObject } from '@/utils/util'
export default {
  name: 'AdvDetail',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      formFields: {
        title: '',
        tag: '',
        enabled: 1,
        duration: 5,
        showPolicy: 0,
        id: this.id
      },
      ruleValidate: {
        title: [
          { required: true, message: '广告主题不能为空!' }
        ],
        duration: [
          { required: true, message: '播放时长不能为空!' }
        ]
      }
    }
  },
  computed: {
    showPolicyList() {
      return this.$config.advShowPolicy
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑广告主题' : '添加广告主题'
      }
    },
    action() {
      return this.$config.apiContextPath + '/adv'
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.id) {
        this.loadingStatus = true
        request({
          url: this.$config.apiContextPath + '/adv/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          applyObject(res.data, this.formFields)
        }).catch(() => {
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
    },
    saveOrUpdate: function() {
      if (this.action) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submit = true
            const isNew = this.formFields.id === 0
            this.formFields.parkingId = this.parkingId
            request({
              url: this.$config.apiContextPath + '/adv' + (isNew ? '' : ('/' + this.id)),
              method: isNew ? 'POST' : 'PUT',
              data: this.formFields
            }).then(res => {
              this.loadingStatus = false
              this.formFields = res.data
              this.$Notice.success({
                title: '数据保存成功',
                desc: '广告主题 `' + this.formFields.title + '` 保存成功!'
              })
              this.submit = false
              this.closeModal(true)
            }).catch(() => {
              this.loadingStatus = false
              this.submit = false
            })
          }
        })
      }
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>
